<template>
  <div class="categories-page-main-block">
    <h2 class="categories-page-main-title">{{ $t("bottomMenu.category") }}</h2>
    <div class="change-status-payments-block">
      <button
        v-for="typeOperation of typeList"
        :key="typeOperation.id"
        :class="[
          `status-button ${activeType &&
            activeType.id === typeOperation.id &&
            'active'}`,
        ]"
        @click="checkListValueType(typeOperation)"
      >
        {{ typeOperation.title }}
      </button>
    </div>
    <div class="created-categories-list">
      <div
        v-for="activity of activityList"
        :key="activity.id"
        class="created-category-item"
        @click="setEditCategories(activity)"
      >
        <div v-if="activity.img" class="category-icon-container">
          <img :src="activity.img" alt="" class="categoty-icon" />
        </div>
        <div v-else class="category-icon-container">
          <question-mark-icon class="categoty-icon" />
        </div>
        <p class="category-name">{{ activity.title }}</p>
      </div>
      <div class="created-category-item" @click="onOpenCreateCategoriesPage">
        <div class="add-category-icon-container">
          <plus-icon class="add-categoty-icon" color="#fff" />
        </div>
        <p class="category-name">{{ $t("homePage.add") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { PlusIcon } from "vue-feather-icons";
import QuestionMarkIcon from "../icons/QuestionMarkIcon.vue";
import { mapMutations } from "vuex";
import { onVibrate } from "../../../helpers/utils";

export default {
  name: "Buttons-top-container",
  components: {
    QuestionMarkIcon,
    PlusIcon,
  },
  props: {
    activeType: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      activityList: [],
      typeList: [],
    };
  },
  async mounted() {
    this.activityList = this.operationsCategories;
    this.typeList = [
      { id: 1, title: this.$t("analytics.costTiitle"), slug: "expense" },
      { id: 2, title: this.$t("analytics.incomeTitle"), slug: "income" },
      // { id: 3, title: this.$t('analytics.transferTitle') }
    ];
  },

  methods: {
    ...mapMutations(["serCreateNewCategories"]),
    checkListValueType(value) {
      onVibrate("click");
      this.$emit("set-check-list-value-type", value);
    },
    onOpenCreateCategoriesPage() {
      onVibrate("click");
      this.$emit("on-open-create-categories-page");
    },
    setEditCategories(category) {
      onVibrate("click");
      this.$emit("set-edit-category", category);
    },
  },
  computed: {
    incomeCategories() {
      return this.$store.getters.incomeCategories;
    },
    costCategories() {
      return this.$store.getters.costCategories;
    },
    otherCategories() {
      return this.$store.getters.otherCategories;
    },
    operationsCategories() {
      return this.$store.getters.operationsCategories;
    },
  },
  watch: {
    // activeType(newVal, oldVal) {
    //     switch (newVal.id) {
    //         case 1:
    //             this.activityList = this.incomeCategories
    //         break
    //         case 2:
    //             this.activityList = this.costCategories
    //         break
    //         case 3:
    //             this.activityList = this.otherCategories
    //         break
    //         default:
    //             this.activityList = this.incomeCategories
    //         break
    //     }
    //     let val = oldVal
    //     val
    // },
    // incomeCategories(newVal, oldVal) {
    //     this.activityList = newVal
    //     let val = oldVal
    //     val
    // },
    // costCategories(newVal, oldVal) {
    //     this.activityList = newVal
    //     let val = oldVal
    //     val
    // },
    // otherCategories(newVal, oldVal) {
    //     this.activityList = newVal
    //     let val = oldVal
    //     val
    // },
    operationsCategories(newVal, oldVal) {
      this.activityList = newVal;
      let val = oldVal;
      val;
    },
  },
};
</script>

<style scoped>
.categories-page-main-block {
  border-radius: 22px;
  width: 95%;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
  padding: 15px;
  margin-bottom: 40px;
  box-shadow: 10px 10px 10px #d1d9e6, -10px -10px 10px #f9f9f9;
}

.categories-page-main-title {
  text-align: center;
}
.change-status-payments-block {
  background-color: rgba(0, 0, 0, 0.07);
  overflow: hidden;
  display: flex;
  padding: 5px;
  border-radius: 20px;
  margin: 10px 0 10px 0;
}

.status-button {
  transition: all 200ms ease;
  text-align: center;
  width: 100%;
  margin: auto;
  color: #000;
  line-height: 35px;
  font-size: 13px;
  background-size: cover;
  position: relative;
  z-index: 10;
  overflow: visible;
  background-color: transparent;
  transition: all 0.5s ease;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
}

.status-button:hover {
  background: #00000016;
}

.status-button.active {
  background-image: var(--main-bg-color);
  color: #fff !important;
}
.status-button.active::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.8) translateY(5px) translateZ(0px);
  filter: blur(12px);
}
.created-categories-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-top: 30px;
}
@media (max-width: 400px) {
  .created-categories-list {
    grid-template-columns: repeat(3, 1fr);
  }
}
.created-category-item {
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.category-icon-container {
  position: relative;
  width: 45px;
  height: 45px;
  background-image: var(--main-bg-color);
  border-radius: 50%;
  display: flex;
  margin: 0 auto;
  z-index: 10;
}

.category-icon-container:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.75) translateY(5px) translateZ(0px);
  filter: blur(8px);
}
.categoty-icon {
  margin: auto;
  fill: #fff;
  width: 25px;
}

.library-icon {
  margin: auto;
  color: #fff;
}
.category-name {
  margin: 0;
  color: #2c2c2c;
  font-size: 13px;
  font-family: "Roboto", sans-serif;
  line-height: 15px;
  font-weight: bolder;
  height: 30px;
  margin-top: 10px;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.add-category-icon-container {
  position: relative;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  display: flex;
  margin: 0 auto;
  background: transparent;
  border: 3px solid #4a89dc;
}

.add-categoty-icon {
  margin: auto;
  color: #4a89dc;
}
</style>
